import type { z } from 'zod'

import type { baseSchema } from '../Forms.config'

type BaseValues = z.infer<typeof baseSchema>

export const SHARED_FIELD_NAMES = [
  'surname',
  'name',
  'patronymic',
  'phoneNumber',
  'email',
  'password',
  'repeatPassword',
  'paymentType',
  'privacyPolicyAgreement',
] as const satisfies ReadonlyArray<keyof BaseValues>

export type SharedFieldName = (typeof SHARED_FIELD_NAMES)[number]

export type SharedFormValues = Partial<Pick<BaseValues, SharedFieldName>>

export type RegisterFormHandle = {
  getSharedValues: () => SharedFormValues
  setSharedValues: (values: SharedFormValues) => void
}

export const pickSharedValues = (
  values: SharedFormValues
): SharedFormValues => {
  const picked: SharedFormValues = {}
  const copy = <K extends SharedFieldName>(name: K) => {
    if (values[name] !== undefined) picked[name] = values[name]
  }
  SHARED_FIELD_NAMES.forEach(copy)
  return picked
}
